// extracted by css-extract-rspack-plugin
export default {"toggle":"czvuQV6XoNY2dur_","label":"mgJTS1zylS4V2eJh"};